{
    "2023-01-01": "Republic Day",
    "2023-01-06": "Epiphany",
    "2023-04-07": "Good Friday",
    "2023-04-10": "Easter Monday",
    "2023-05-01": "Labor Day",
    "2023-05-08": "Day of Victory Over Fascism",
    "2023-07-05": "St. Cyril & St. Methodius Day",
    "2023-08-29": "National Uprising Day",
    "2023-09-01": "Constitution Day",
    "2023-09-15": "Day of Our Lady of Sorrows",
    "2023-11-01": "All Saints' Day",
    "2023-11-17": "Fight for Freedom and Democracy Day",
    "2023-12-24": "Christmas Eve",
    "2023-12-25": "Christmas Day",
    "2023-12-26": "St. Stephen's Day",
    "2024-01-01": "Republic Day",
    "2024-01-06": "Epiphany",
    "2024-03-29": "Good Friday",
    "2024-04-01": "Easter Monday",
    "2024-05-01": "Labor Day",
    "2024-05-08": "Day of Victory Over Fascism",
    "2024-07-05": "St. Cyril & St. Methodius Day",
    "2024-08-29": "National Uprising Day",
    "2024-09-01": "Constitution Day",
    "2024-09-15": "Day of Our Lady of Sorrows",
    "2024-11-01": "All Saints' Day",
    "2024-11-17": "Fight for Freedom and Democracy Day",
    "2024-12-24": "Christmas Eve",
    "2024-12-25": "Christmas Day",
    "2024-12-26": "St. Stephen's Day",
    "2025-01-01": "Republic Day",
    "2025-01-06": "Epiphany",
    "2025-04-18": "Good Friday",
    "2025-04-21": "Easter Monday",
    "2025-05-01": "Labor Day",
    "2025-05-08": "Day of Victory Over Fascism",
    "2025-07-05": "St. Cyril & St. Methodius Day",
    "2025-08-29": "National Uprising Day",
    "2025-09-01": "Constitution Day",
    "2025-09-15": "Day of Our Lady of Sorrows",
    "2025-11-01": "All Saints' Day",
    "2025-11-17": "Fight for Freedom and Democracy Day",
    "2025-12-24": "Christmas Eve",
    "2025-12-25": "Christmas Day",
    "2025-12-26": "St. Stephen's Day",
    "2026-01-01": "Republic Day",
    "2026-01-06": "Epiphany",
    "2026-04-03": "Good Friday",
    "2026-04-06": "Easter Monday",
    "2026-05-01": "Labor Day",
    "2026-05-08": "Day of Victory Over Fascism",
    "2026-07-05": "St. Cyril & St. Methodius Day",
    "2026-08-29": "National Uprising Day",
    "2026-09-01": "Constitution Day",
    "2026-09-15": "Day of Our Lady of Sorrows",
    "2026-11-01": "All Saints' Day",
    "2026-11-17": "Fight for Freedom and Democracy Day",
    "2026-12-24": "Christmas Eve",
    "2026-12-25": "Christmas Day",
    "2026-12-26": "St. Stephen's Day",
    "2027-01-01": "Republic Day",
    "2027-01-06": "Epiphany",
    "2027-03-26": "Good Friday",
    "2027-03-29": "Easter Monday",
    "2027-05-01": "Labor Day",
    "2027-05-08": "Day of Victory Over Fascism",
    "2027-07-05": "St. Cyril & St. Methodius Day",
    "2027-08-29": "National Uprising Day",
    "2027-09-01": "Constitution Day",
    "2027-09-15": "Day of Our Lady of Sorrows",
    "2027-11-01": "All Saints' Day",
    "2027-11-17": "Fight for Freedom and Democracy Day",
    "2027-12-24": "Christmas Eve",
    "2027-12-25": "Christmas Day",
    "2027-12-26": "St. Stephen's Day",
    "2028-01-01": "Republic Day",
    "2028-01-06": "Epiphany",
    "2028-04-14": "Good Friday",
    "2028-04-17": "Easter Monday",
    "2028-05-01": "Labor Day",
    "2028-05-08": "Day of Victory Over Fascism",
    "2028-07-05": "St. Cyril & St. Methodius Day",
    "2028-08-29": "National Uprising Day",
    "2028-09-01": "Constitution Day",
    "2028-09-15": "Day of Our Lady of Sorrows",
    "2028-11-01": "All Saints' Day",
    "2028-11-17": "Fight for Freedom and Democracy Day",
    "2028-12-24": "Christmas Eve",
    "2028-12-25": "Christmas Day",
    "2028-12-26": "St. Stephen's Day"
}
